import React from 'react';
import langConf from "../js/lang";


class Landing extends React.Component {


    handleClick = async (event) => {
        const lang = this.props.language;
        event.preventDefault();
        //console.log(document.querySelector('#accept').checked);
        if (document.querySelector('#accept').checked)
            await this.props.changeScreen('validation');
        else
            alert(`${langConf[lang].errorReadTerms}`);
    };

    render() {
        const lang = this.props.language;
        //https://sheleg.co.il/#elementor-action%3Aaction%3Dpopup%3Aopen%26settings%3DeyJpZCI6IjQxMTEiLCJ0b2dnbGUiOmZhbHNlfQ%3D%3D
        return (
            <div className='col-xl-12'>
                <div className="col-xl-2 col-lg-3 col-md-0 col-sm-0 col-0"></div>
                <div className='form-group col-xl-8 col-lg-6 col-md-12 col-sm-12 col-12' style={lang === 'hebrew' ? {marginBottom: '0px', direction: 'rtl'} : {marginBottom: '0px', direction: 'ltr'}}>
                    <h6>{langConf[lang].landingThanks}</h6>
                    <p>{langConf[lang].intro1}</p>
                    <p>{langConf[lang].intro2}</p>
                    <p>{langConf[lang].step1}</p>
                    <p>{langConf[lang].step2}</p>
                    <p>{langConf[lang].finally}</p>
                    <div className="form-group col-xl-12" style={lang === 'hebrew' ? {direction: 'ltr', marginBottom: '0px'} : {direction: 'rtl', marginBottom: '0px'}}>
                        <label><a href={langConf[lang].termsURL} style={{marginRight: '5px'}} target="_blank" rel="noopener noreferrer">{langConf[lang].acceptTerms}</a></label>
                        
                        <input type="checkbox" id="accept"></input>
                    </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-0 col-sm-0 col-0"></div>
                <div className="col-xl-12">
                    <div className="col-xl-4 col-lg-4 col-md-2 col-sm-0 col-0"></div>
                    <div className='form-group col-xl-4 col-lg-4 col-md-8 col-sm-12 col-12'>
                        <button className='btn btn-success btn-lg btn-block' id="toRegistration" onClick={this.handleClick}><i className={`fas fa-user-plus`}></i>{` ${langConf[lang].serviceRegistration}`}</button>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-2 col-sm-0 col-0"></div>
                </div>
            </div>
        );
    }
}

export default Landing;